import axios from 'axios';
import { RegisterData, RegisterResponse, TariffPlan } from '../types/account';
import {BlogPost} from "../types/blog";

export const API_BASE_URL = import.meta.env.VITE_API_ROOT;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': "*"
  }
});

export const accountApi = {
  register: async (data: RegisterData): Promise<RegisterResponse> => {
    const response = await api.post('/api/account/register', data);
    return response.data;
  },

  activate: async (token: string): Promise<void> => {
    await api.post(`/api/account/activate/${token}`);
  },

  getTariffPlans: async (): Promise<TariffPlan[]> => {
    const response = await api.get('/api/tariff/available');
    return response.data;
  },
};
export const blogApi = {
  getPosts: async (): Promise<BlogPost[]> => {
    const response = await api.get('/api/blogs');
    return response.data;
  },

  getPost: async (slug: string): Promise<BlogPost> => {
    const response = await api.get(`/api/blogs/${slug}`);
    return response.data;
  }
};
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY as string;
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string;
